import { render, staticRenderFns } from "./ESGServices.vue?vue&type=template&id=1245b476&scoped=true"
import script from "./ESGServices.vue?vue&type=script&lang=js"
export * from "./ESGServices.vue?vue&type=script&lang=js"
import style0 from "./ESGServices.vue?vue&type=style&index=0&id=1245b476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1245b476",
  null
  
)

export default component.exports